// import axios from "axios";

// const API_URL = process.env.REACT_APP_API_BASE_URL;

// export const getDatabases = () => axios.get(`${API_URL}/databases`);

// export const getDatabasesWithCount = () =>
//   axios.get(`${API_URL}/databases/withCount`);

// export const addDatabase = (data) =>
//   axios.post(`${API_URL}/databases`, data);

// export const deleteDatabases = (ids) =>
//   axios.post(`${API_URL}/databases/delete`, { ids });

// export const importContacts = (dbId, contacts) =>
//   axios.post(`${API_URL}/databases/${dbId}/import`, { contacts });

// export const getContactsByDatabase = (dbId) =>
//   axios.get(`${API_URL}/databases/${dbId}/contacts`);

// // ===== GLOBAL SEARCH AND DELETE CONTACT BY EMAIL =====
// export const searchContactByEmail = (email) =>
//   axios.get(`${API_URL}/contacts/search?email=${encodeURIComponent(email)}`, {
//     headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
//   });

// export const deleteContactByEmail = (email) =>
//   axios.delete(`${API_URL}/contacts/by-email`, {
//     headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//     data: { email }
//   });


import axios from "axios";

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const getDatabases = () => axios.get(`${API_URL}/databases`);

export const getDatabasesWithCount = () =>
  axios.get(`${API_URL}/databases/withCount`);

export const addDatabase = (data) =>
  axios.post(`${API_URL}/databases`, data);

export const deleteDatabases = (ids) =>
  axios.post(`${API_URL}/databases/delete`, { ids });

export const importContacts = (dbId, contacts) =>
  axios.post(`${API_URL}/databases/${dbId}/import`, { contacts });

export const getContactsByDatabase = (dbId) =>
  axios.get(`${API_URL}/databases/${dbId}/contacts`);

// ===== GLOBAL SEARCH AND DELETE CONTACT BY EMAIL =====
export const searchContactByEmail = (email) =>
  axios.get(`${API_URL}/contacts/search?email=${encodeURIComponent(email)}`);

export const deleteContactByEmail = (email) =>
  axios.delete(`${API_URL}/contacts/by-email`, {
    data: { email }
  });
  